<template>
  <v-container>
    <bread-crumbs :items="breadCrumbs"/>

    <v-dialog v-model="dialogNew" max-width="330">
      <v-card class="pa-2">
        <v-icon small class="size" color="main" @click="dialogNew = false">mdi-close</v-icon>
        <v-card-text class="text-center">
          <custom-text-field label="نام اپلیکیشن" v-model="appName" class="mt-1"/>
          <custom-text-field label="آی دی اپلیکیشن" v-model="appId" class="mt-1"/>
        </v-card-text>

        <v-card-actions class="">
          <v-btn class="primary w-100 mb-3" dark @click="confirmNew">ایجاد</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="330">
      <v-card class="pa-2">
        <v-icon small class="size" color="main" @click="dialog = false">mdi-close</v-icon>
        <v-card-text class="text-center">
          <v-img src="/img/warning.png" width="120" class="mx-auto mb-2"/>
          <span class="textMainColor">آیا از تغییر نقش به ادمین مطمئن هستید؟</span>
        </v-card-text>

        <v-card-actions class="">
          <v-btn class="primary w-100 mb-3" dark @click="confirm">تائید</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pa-5">
      <v-row class="mt-6">
        <v-col cols="12" sm="3" md="3" lg="3">
          <label>تاريخ شروع ارائه خدمات(شمسی)</label>
          <date-picker auto-submit v-model="startDate" ></date-picker>
        </v-col>

        <v-col cols="12" sm="3" md="3" lg="3">
          <label>تاريخ خاتمه ارائه خدمات(شمسی)</label>
          <date-picker
            auto-submit
            :min="startDate"
            v-model="endDate"
            :disabled="endDateDisable"
          ></date-picker>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3">
          <label> تاريخ شروع صورتحساب </label>
          <date-picker auto-submit v-model="start_bill_date"></date-picker>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3">
          <label>تاريخ خاتمه صورتحساب</label>
          <date-picker
            auto-submit
            :min="start_bill_date"
            v-model="end_bill_date"
            :disabled="endBillDateDisable"
          ></date-picker>
        </v-col>
      </v-row>

      <v-row class="mt-6">
        <v-col cols="12" sm="4" md="3" lg="3">
          <custom-text-field label="شماره صورتحساب" v-model="search_bill_number" class="mt-1"/>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="3">
          <custom-text-field label=" کد مشتری" v-model="search_customer_code" class="mt-1"/>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="3">
          <custom-text-field label=" بهره بردار" v-model="search_customer_name" class="mt-1"/>
        </v-col>

        <v-col cols="12" sm="2" lg="2" class="d-flex">
          <v-btn
            small
            align="center"
            justify="center"
            class="indigo mt-1 pa-4"
            @click="filter"
          >
            فیلتر
          </v-btn>
          <v-btn
            small
            align="center"
            justify="center"
            class="warning mx-auto mt-1 mr-2 pa-4"
            @click="resetForm"
          >
            <v-icon color="">mdi-refresh-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>


    <v-card class="pt-8 mt-3">
      <h4 class="container-title">لیست قرارداد های 1400 </h4>
      <p class="col-12 text-center font-weight-bold">گزارش سیستم فروش(CRM)</p>
      <p class="col-12 text-center font-weight-bold" v-if="startDate && endDate">برای سال مالی 1400 از تاریخ {{startDate}}  لغایت  {{endDate}}</p>
      <v-row v-if="contractsListData[0]" class="pa-5 pr-10 myBox">

        <p class="col-6"><span>تعداد:</span> <span>{{ contractsListData[0].count }}</span></p>
        <p class="col-6"><span>جمع کل مبلغ فروش:</span> <span>{{ thousandComma(contractsListData[0].totalSell) }}</span>
        </p>
        <p class="col-6"><span>جمع کل مبلغ برگشت از فروش :</span><span>{{ thousandComma(contractsListData[0].totalBackSell) }}</span>
        </p>
        <p class="col-6">
          <span>جمع کل مبلغ تخفیفات:</span><span>{{ thousandComma(contractsListData[0].totalDiscount) }}</span></p>
        <p class="col-6">
          <span> مالیات و عوارض بر ارزش افزوده فروش:</span><span>{{
            thousandComma(contractsListData[0].totalTax)
          }}</span>
        </p>
        <p class="col-6">
          <span>جمع فروش خالص به علاوه ارزش افزوده:</span><span>{{
            thousandComma(contractsListData[0].totalSell_and_tax)
          }}</span>
        </p>
      </v-row>
      <v-card-text class="pa-5">
        <v-sheet elevation="4" v-if="contractsListData[0]" class="mt-5">

          <v-row class="d-flex mb-5">
            <export-excel
              class="btn btn-default"
              :data="contractsListData[0].contracts"
              :fields="json_fields"
              :title="excelTitle"
              :worksheet="fileName"
              :name="`${fileName}.xls`">

              <v-btn color="indigo darken-1"> خروجی اکسل</v-btn>

            </export-excel>
            <export-excel
              class="btn btn-default"
              :data="secondExcel"
              :fields="json_fields2"
              :title="excelTitle2"
              :worksheet="fileName"
              :name="`${fileName}.xls`">

              <v-btn color="indigo darken-1"> خروجی اکسل اطلاعات کلی</v-btn>

            </export-excel>

<!--            <v-btn class="btn-default" color="indigo" @click="printPage">پرینت</v-btn>-->
          </v-row>


          <v-data-table
            id="exportTable"
            :headers="headers"
            :items="contractsListData[0].contracts"
            :items-per-page="10"
            class="elevation-3"
            :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-plus',
        nextIcon: 'mdi-minus',
        itemsPerPageOptions:[10,15]
      }"
          >
            <template v-slot:[`item.show`]="{ item }">

              <v-tooltip bottom class="hand">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on" small color="primary" class="mr-2 hand"
                    @click="openNewWindow(item)"
                  >
                    mdi-magnify-scan
                  </v-icon>
                </template>
                <span>نمایش فاکتور </span>
              </v-tooltip>
              <!--@click="$router.push({name:'FactorsList',params:{id:item.bill_number}})"-->

            </template>
            <template v-slot:[`item.has_rack`]="{ item }">

              <v-tooltip bottom class="hand">
                <template v-if="item.has_rack" v-slot:activator="{ on }">
                  <v-icon
                    v-on="on" small color="primary" class="mr-2 hand"
                    @click="openNewWindowRack(item)"
                  >
                    mdi-magnify-scan
                  </v-icon>
                </template>
                <span>نمایش رک </span>
              </v-tooltip>
              <!--@click="$router.push({name:'FactorsList',params:{id:item.bill_number}})"-->

            </template>

            <template v-slot:[`item.contract_cost`]="{ item }">{{ thousandComma(item.contract_cost) }}</template>
            <template v-slot:[`item.sell`]="{ item }">{{ thousandComma(item.sell) }}</template>
            <template v-slot:[`item.discount`]="{ item }">{{ thousandComma(item.discount) }}</template>
            <template v-slot:[`item.net_sell`]="{ item }">{{ thousandComma(item.net_sell) }}</template>
            <template v-slot:[`item.tax`]="{ item }">{{ thousandComma(item.tax) }}</template>
            <template v-slot:[`item.sell_and_tax`]="{ item }">{{ thousandComma(item.sell_and_tax) }}</template>

            <template v-slot:[`item.bill_date`]="{ item }">{{ transformDateToJalali(item.bill_date) }}</template>
            <template v-slot:[`item.start_date`]="{ item }">{{ transformDateToJalali(item.start_date) }}</template>
            <template v-slot:[`item.end_date`]="{ item }">{{ transformDateToJalali(item.end_date) }}</template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import CustomTextField from "@/components/base/CustomTextField";
import {thousandComma} from "@/plugins/helper";

export default {
  name: "contractList",
  components: {CustomTextField},
  data() {
    return {
      thousandComma,
      page: 1,
      totalUsers: 0,
      numberOfPages: 0,
      loading: true,
      options: {},
      confirmID: null,
      dialog: false,
      dialogConsult: false,
      dialogAdmin: false,
      totalDesserts: 0,
      desserts: [],
      breadCrumbs: [
        {
          text: "داشبورد",
          disabled: false,
          to: {name: "Dashboard"},
          exact: true,
        },
        {
          text: "لیست قرارداد های 1400",
          disabled: true,
          exact: true,
        },
      ],

      headers: [
        {text: "نمایش فاکتور", value: "show", sortable: false},
        {text: "کد مشتری", value: "customer_code", sortable: true},
        {text: "بهره بردار", value: "customer_name", sortable: true, width: '230px'},
        {text: "یونیت", value: "unit", sortable: true},
        {text: "رک", value: "rack", sortable: true},
        {text: "نمایش رک", value: "has_rack", sortable: true},
        {text: "سرور اختصاصی", value: "server", sortable: true},
        {text: "شماره قرارداد", value: "contract_number", sortable: true},
        {text: "الحاقیه 1", value: "el1", sortable: true},
        {text: "الحاقیه 2", value: "el2", sortable: true},
        {text: "الحاقیه 3", value: "el3", sortable: true},
        {text: "مبلغ الحاقیه 1", value: "el1_cost", sortable: true},
        {text: "مبلغ الحاقیه 2", value: "el2_cost", sortable: true},
        {text: "مبلغ الحاقیه 3", value: "el3_cost", sortable: true},
        {text: "تاريخ قرارداد شروع(شمسی)", value: "contract_start_date", sortable: true},
        {text: "تاريخ قرارداد خاتمه(شمسی)", value: "contract_end_date", sortable: true},
        {text: "مبلغ قرارداد (اسناد دريافتني)", value: "", sortable: true},
        {text: "مبلغ قرارداد", value: "contract_cost", sortable: true},
        {text: "مبلغ قرارداد نهایی(بعد از الحاقیه1)", value: "contract_cost_el1", sortable: true},
        {text: "مبلغ قرارداد نهایی(بعد از الحاقیه2)", value: "contract_cost_el2", sortable: true},
        {text: "مبلغ قرارداد نهایی(بعد از الحاقیه3)", value: "contract_cost_el3", sortable: true},
        {text: "شماره صورتحساب", value: "bill_number", sortable: true},
        {text: "تاریخ صورتحساب", value: "bill_date", sortable: true},
        {text: "فروش ", value: "sell", sortable: true},
        {text: "تخفیف", value: "discount", sortable: true},
        {text: "فروش خالص", value: "net_sell", sortable: true},
        {text: "مالیات بر ارزش افزوده ", value: "tax", sortable: true},
        {text: "جمع فروش بعلاوه ارزش افزوده", value: "sell_and_tax", sortable: true},
        {text: "تاريخ شروع(شمسی)", value: "start_date", sortable: true},
        {text: "تاريخ خاتمه(شمسی)", value: "end_date", sortable: true},
        // {text: "شماره موبایل ", value: "phoneNumber", sortable: false},

      ],

      searchName: '',
      searchMobile: '',
      confirmMethod: null,
      confirmRole: '',
      introductionLetterUrl: '',
      lawDocumentUrl: '',
      confirmStateId: '',
      dialogState: false,
      dialogUserProfile: false,
      dialogNew: false,
      appName: '',
      appId: '',
      search_customer_name: '',
      search_customer_code: '',
      search_bill_number: '',
      start_bill_date: '',
      end_bill_date: '',
      endBillDateDisable:false,

      json_fields: {
        "کد مشتری": 'customer_code',
        "بهره بردار ": 'customer_name',
        "یونیت ": 'unit',
        "سرور اختصاصی ": 'server',
        "شماره قرارداد ": 'contract_number',
        "الحاقیه 1 ": 'el1',
        "الحاقیه 2 ": 'el2',
        "الحاقیه 3 ": 'el3',
        "مبلغ الحاقیه 1 ": 'el1_cost',
        "مبلغ الحاقیه 2 ": 'el2_cost',
        "مبلغ الحاقیه 3 ": 'el3_cost',
        "تاريخ قرارداد شروع(شمسی)": 'contract_start_date',
        "تاريخ قرارداد خاتمه(شمسی)": 'contract_end_date',
        //"مبلغ قرارداد (اسناد دريافتني)": '',
        "مبلغ قرارداد": 'contract_cost',
        "مبلغ قرارداد نهایی(بعد از الحاقیه1)": 'contract_cost_el1',
        "مبلغ قرارداد نهایی(بعد از الحاقیه2)": 'contract_cost_el2',
        "مبلغ قرارداد نهایی(بعد از الحاقیه3)": 'contract_cost_el3',
        "شماره صورتحساب": 'bill_number',
        "تاریخ صورتحساب": {
          field: 'bill_date',
          callback: (value) => {
            return this.transformDateToJalali(value);
          }
        },
        "فروش": 'sell',
        "تخفیف": 'discount',
        "فروش خالص": 'net_sell',
        "مالیات بر ارزش افزوده": 'tax',
        "جمع فروش بعلاوه ارزش افزوده": 'sell_and_tax',
        "تاريخ شروع(شمسی)": {
          field: 'start_date',
          callback: (value) => {
            return this.transformDateToJalali(value);
          }
        },
        "تاريخ خاتمه(شمسی)": {
          field: 'end_date',
          callback: (value) => {
            return this.transformDateToJalali(value);
          }
        },
      },
      json_fields2: {
        '': " ",
        "جمع کل مبلغ فروش": 'totalSell',
        "جمع کل مبلغ برگشت از فروش": 'totalBackSell',
        "جمع کل مبلغ تخفیفات": 'totalDiscount',
        "مالیات و عوارض بر ارزش افزوده فروش": 'totalTax',
        "جمع فروش خالص به علاوه ارزش افزوده": 'totalSell_and_tax',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],

      startDate: '',
      endDate: "",
      endDateDisable: false,


    };
  },

  computed: {
    secondExcel: {
      get() {
        return [
          {
            totalSell: this.contractsListData[0].totalSell,
            totalBackSell: this.contractsListData[0].totalBackSell,
            totalDiscount: this.contractsListData[0].totalDiscount,
            totalTax: this.contractsListData[0].totalTax,
            totalSell_and_tax: this.contractsListData[0].totalSell_and_tax
          },
          {
            totalSell: "",
            totalBackSell: '',
            totalDiscount: '',
            totalTax: '',
            totalSell_and_tax: ''
          },
          {
            totalSell: "فروش",
            totalBackSell: '',
            totalDiscount: '',
            totalTax: '',
            totalSell_and_tax: 'مدیرعامل'
          }
        ]
      }
    },
    contractsListData: {
      get() {
        return this.$store.getters["company/getContracts"];
      },
      set(value) {
      },
    },

    excelTitle: {
      get() {
        return [
          `گزارش سیستم فروش (CRM)`,
          `برای سال مالی 1400`,
          `ار تاریخ ${this.startDate}لغایت  ${this.endDate}`,
        ]
      },
      set(value) {
      },
    },
    excelTitle2: {
      get() {
        return [
          `گزارش سیستم فروش (CRM)`,
          `برای سال مالی 1400`,
          `ار تاریخ ${this.startDate}لغایت  ${this.endDate}`,
          ''
        ]
      },
      set(value) {
      },
    },


    fileName: {
      get() {
        return `contractReport`
        //return `${this.userProfile.firstName} ${this.userProfile.lastName}`
      },
      set(value) {
      },
    },

  },
  watch: {
    // options: {
    //   handler() {
    //     this.readDataFromAPI();
    //   },
    // },
    startDate: {
      handler() {
        console.log(this.startDate)
        if (this.startDate != "") {
          this.$store.commit('company/SET_CONTRACTS',[])
          this.endDateDisable = false;
          this.endDate = "";
        } else {
          this.endDateDisable = true;
          this.endDate = "";
        }
      },
    },

  },
  async mounted() {
    await this.$store.dispatch('company/fetchContracts',{
      start_date: this.convertDateToTimestamp(this.startDate),
      end_date: this.convertDateToTimestamp(this.endDate) + 24 * 3600 * 1000,
      bill_date_start_date: this.convertDateToTimestamp(this.start_bill_date),
      bill_date_end_date: this.convertDateToTimestamp(this.end_bill_date)+ 24 * 3600 * 1000,
    })
  },
  methods: {
    checkType(data) {
      return typeof data.item !== "object";
    },

    async readDataFromAPI() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let data = await this.$store.dispatch("app/fetchAppList", {
        page: page,
        count: itemsPerPage,
        // name: this.searchName,

      });
      this.loading = false;
      ////console.log("data.limit", data.limit);
      this.appData = data.docs;
      this.totalUsers = data.totalDocs;
      this.numberOfPages = data.totalPages;
    },


    setIdConfirm(item, method) {
      this.confirmID = item._id;
      this.confirmRole = item.role;
      this.confirmMethod = method;
      this.dialog = true;
    },

    async confirm() {
      this.dialog = false;
      await this.confirmMethod();
      await this.readDataFromAPI();
    },

    async filter() {
      // this.convertDateToTimestamp(this.startDate),
      await this.$store.dispatch("company/fetchContracts", {
        bill_number: this.search_bill_number,
        start_date: this.convertDateToTimestamp(this.startDate),
        end_date: this.convertDateToTimestamp(this.endDate) + 24 * 3600 * 1000,
        customer_code: this.search_customer_code,
        customer_name: this.search_customer_name,
        bill_date_start_date: this.convertDateToTimestamp(this.start_bill_date),
        bill_date_end_date: this.convertDateToTimestamp(this.end_bill_date)+ 24 * 3600 * 1000,
      });
    },

    async confirmNew() {
      this.dialogNew = false;
      await this.$store.dispatch('app/createApp', {
        appName: this.appName,
        appId: this.appId
      })
      await this.readDataFromAPI();

    },
    pushToStreamPage(item) {
      console.log(item)
      this.$router.push({name: 'StreamList', params: {id: item._id, name: item.appName}})
    },
    resetForm() {
      this.start_bill_date = ''
      this.end_bill_date = ''
      this.startDate = ''
      this.endDate = ''
      this.search_customer_name = ''
      this.search_customer_code = ''
      this.search_bill_number = ''
    },
    transformDateToJalali(value) {
      return moment(value).format('jYYYY/jMM/jDD')
    },
    convertDateToTimestamp(date) {
      return new Date(
        moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD")
      ).getTime();
    },
    openNewWindow(item) {
      window.open(`/factors-list/${item.bill_number}`, '_blank')
    },
    openNewWindowRack(item) {
      window.open(`/rack-list/${item.customer_code}`, '_blank')
    },
    printPage() {
      // Get HTML to print from element
      const prtHtml = document.getElementById('exportTable').innerHTML;
      console.log(prtHtml)
// Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

// Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`${prtHtml}`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
    /**
     * In a real application this would be a call to fetch() or axios.get()
     */
  },
};
</script>

<style>
.v-text-field__slot input {
  color: black !important;
}

body {
  text-align: right;
}

td {
  /*color: black !important;*/
}

.myBox p {
  border: solid 1px grey;
}
.myBox p span:nth-child(2){
  direction: ltr;
  font-weight: bold;
  text-align: left;
}
</style>
